const config = {
  baseApiURL: `${process.env.REACT_APP_BASE_API_URL}`,
  defaultTimeout: 1000 * 60 * 10,
  defaultTokenExpires: 365,
}

export const ADMIN_PATH_AFTER_LOGIN = '/admin/dashboard/project'
export const GOOGLE_CLIENT_ID =
  '745213284708-fra9cqv1hq42a2kd6ies10q47qdabu3j.apps.googleusercontent.com'
export default config
